var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToprightarrowred({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint0_linear_4275_4528)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 28L28 16M28 16H19M28 16V25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4275_4528",
    x1: 4.55063,
    y1: 8.07087e-7,
    x2: 39.4494,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E84141"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToprightarrowred);
export default __webpack_public_path__ + "static/media/toprightarrowred.a9bec6a22114674eae669b718a8b90ca.svg";
export { ForwardRef as ReactComponent };